import './boot.css';

declare global {
	interface Window {
		forceReload: () => void;
	}
}

window.forceReload = () => {
	const delimiter = window.location.href.includes('?') ? '&' : '?';
	window.location.href = `${window.location.href + delimiter}cacheBreaker=${Math.random()}`;
};

// Checks whether the base Path equals to location.pathname with case-sensitive.
// If the register doesn't match, the base Path will be substituted by value from location.pathname as template for all relative URLs in a document.
let basePath;
const baseElement = document.getElementsByTagName('base')[0];
if (baseElement) {
	const attrHref = baseElement.attributes.getNamedItem('href');
	if (!!attrHref && !!attrHref.value && attrHref.value !== '/') {
		basePath = attrHref.value.replace(/^(https?:)?\/\/[^/]*/, '').toLowerCase();
		const pathname = window.location.pathname.toLowerCase();
		const startIndex = pathname.indexOf(basePath);
		if (startIndex !== -1) {
			attrHref.value = window.location.pathname.substring(startIndex, basePath.length);
		}
	}
}

function get_browser_info() {
	const ua = navigator.userAgent;
	let tem,
		M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return { name: 'IE', version: tem[1] || '' };
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\bOPR\/(\d+)/);
		if (tem !== null) {
			return { name: 'Opera', version: tem[1] };
		}
	}
	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
		M.splice(1, 1, tem[1]);
	}
	return {
		name: M[0],
		version: M[1],
	};
}

const browser = get_browser_info();

// Checks the browser name and version.
// This checking should be before loading any scripts and DOM elements that could make critical changes in processing of page (e.g. redefining location).
// In case the browser is not supported we will be redirected to the proper page with an appropriate describing.
const browserIsSupported = !(
	((browser.name === 'IE' || browser.name === 'MSIE') && parseInt(browser.version, 10) <= 11) ||
	(browser.name === 'Safari' && parseInt(browser.version, 10) <= 5)
);

if (!browserIsSupported) {
	window.location.href = window.location.origin + (basePath || '/') + 'unsupported-browser.html';
}
